import React, { useState } from "react";
import { Button, Carousel } from "antd";
import * as CarouselItem from "./img";
import { motion } from "framer-motion";
import { PauseCircleTwoTone, PlayCircleTwoTone, ShopOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { backtoTopFunction } from "./components/BacktoTop";

const carouselStyle = {
  minHeight: "200px",
  minWidth: "300px",
  height: "50%",
  width: "100%",
  // lineHeight: '1800px',
  color: "#fff",
  textAlign: "center",
  background: "#364d79",
  // zPosition : -1
};

const FeaturedCarousel = () => {
  const [autoplayStatus, setAutoplay] = useState(true);

  const navi = useNavigate();

  // const innerheight = () => {
  //   let styleCustom1={
  //     height: (window.innerHeight-500)+"px",
  //     width: "100%",
  //     position: "relative"
  //   }
  //   console.log(styleCustom1.height)
  //   return styleCustom1
  // }

  // const generateImgcarousel = () => {
  //   CarouselItem.imgprojectsample.map((item,i) =>
  //   <li key={i}>Test {item}</li>

  //   )
  // }

  return (
    <motion.div
      // key={selectedTab ? selectedTab.label : "empty"} //affect for giving transition to your next object/image
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      // animate={{ x: [0, 100, 0] }}
      // exit={{ opacity: 0, y: -20 }}
      transition={{ ease: "easeIn", duration: 0.8 }}
    >
      <Carousel
        style={carouselStyle}
        autoplay={autoplayStatus}
        autoplaySpeed="50"
        draggable={true}
        // swipeToSlide={true}
        pauseOnHover={false}
        pauseOnDotsHover={true}
        effect={"fade"}
      >
        {CarouselItem.sliderimg.map((index, i) => (
          <div key={i} className="carouselContainer">
            <img src={index.img} className="carouselItem" alt="noImg" />
            <div className="carouselcaptionbox carouselcaption">
              <h2 style={{ color: "white" }}>
               {index.desc}
                {/* The Slider! Hover to me to pause!{" "} */}
              </h2>
              {i === 0 ? (
                <Button
                  size={"large"}
                  type="default"
                  style={{
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    color: "white",
                  }}
                  onClick={() => navi("/project")}
                >
                  {index.btnCaption}
                </Button>
              ) : (
                ""
              )}
            </div>
          </div>
        ))}
      </Carousel>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginRight: "1vw",
        }}
      >
      {/* <Button type="dashed" onClick={()=> (navi('/project'),backtoTopFunction())} style={{marginRight:"1vw"}}>My Projects <ShopOutlined /></Button> */}
        <Button type="primary" onClick={() => setAutoplay(!autoplayStatus)}>
          Autoplay :{" "}
          {autoplayStatus ? (
            <>
              Auto <PlayCircleTwoTone />
            </>
          ) : (
            <>
              Paused <PauseCircleTwoTone />
            </>
          )}
        </Button>
      </div>
    </motion.div>
  );
};

export default FeaturedCarousel;
